/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CarrierType } from '../model';
// @ts-ignore
import type { CarrierVisitDirection } from '../model';
// @ts-ignore
import type { CreateGlobalAllocationAndRulesDto } from '../model';
// @ts-ignore
import type { GlobalAllocationRuleDto } from '../model';
/**
 * GlobalAllocationRulesApi - axios parameter creator
 */
export const GlobalAllocationRulesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateGlobalAllocationAndRulesDto} [createGlobalAllocationAndRulesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalAllocationRulesCreateGlobalRuleAndAllocation: async (createGlobalAllocationAndRulesDto?: CreateGlobalAllocationAndRulesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GlobalAllocationRules/CreateGlobalRuleAndAllocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGlobalAllocationAndRulesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CarrierVisitDirection} [direction] 
         * @param {CarrierType} [carrierType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalAllocationRulesGet: async (direction?: CarrierVisitDirection, carrierType?: CarrierType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GlobalAllocationRules/Get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (carrierType !== undefined) {
                localVarQueryParameter['carrierType'] = carrierType;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GlobalAllocationRulesApi - functional programming interface
 */
export const GlobalAllocationRulesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GlobalAllocationRulesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateGlobalAllocationAndRulesDto} [createGlobalAllocationAndRulesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async globalAllocationRulesCreateGlobalRuleAndAllocation(createGlobalAllocationAndRulesDto?: CreateGlobalAllocationAndRulesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.globalAllocationRulesCreateGlobalRuleAndAllocation(createGlobalAllocationAndRulesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GlobalAllocationRulesApi.globalAllocationRulesCreateGlobalRuleAndAllocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CarrierVisitDirection} [direction] 
         * @param {CarrierType} [carrierType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async globalAllocationRulesGet(direction?: CarrierVisitDirection, carrierType?: CarrierType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GlobalAllocationRuleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.globalAllocationRulesGet(direction, carrierType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GlobalAllocationRulesApi.globalAllocationRulesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GlobalAllocationRulesApi - factory interface
 */
export const GlobalAllocationRulesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GlobalAllocationRulesApiFp(configuration)
    return {
        /**
         * 
         * @param {GlobalAllocationRulesApiGlobalAllocationRulesCreateGlobalRuleAndAllocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalAllocationRulesCreateGlobalRuleAndAllocation(requestParameters: GlobalAllocationRulesApiGlobalAllocationRulesCreateGlobalRuleAndAllocationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.globalAllocationRulesCreateGlobalRuleAndAllocation(requestParameters.createGlobalAllocationAndRulesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GlobalAllocationRulesApiGlobalAllocationRulesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalAllocationRulesGet(requestParameters: GlobalAllocationRulesApiGlobalAllocationRulesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GlobalAllocationRuleDto>> {
            return localVarFp.globalAllocationRulesGet(requestParameters.direction, requestParameters.carrierType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for globalAllocationRulesCreateGlobalRuleAndAllocation operation in GlobalAllocationRulesApi.
 */
export interface GlobalAllocationRulesApiGlobalAllocationRulesCreateGlobalRuleAndAllocationRequest {
    readonly createGlobalAllocationAndRulesDto?: CreateGlobalAllocationAndRulesDto
}

/**
 * Request parameters for globalAllocationRulesGet operation in GlobalAllocationRulesApi.
 */
export interface GlobalAllocationRulesApiGlobalAllocationRulesGetRequest {
    readonly direction?: CarrierVisitDirection

    readonly carrierType?: CarrierType
}

/**
 * GlobalAllocationRulesApi - object-oriented interface
 */
export class GlobalAllocationRulesApi extends BaseAPI {
    /**
     * 
     * @param {GlobalAllocationRulesApiGlobalAllocationRulesCreateGlobalRuleAndAllocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public globalAllocationRulesCreateGlobalRuleAndAllocation(requestParameters: GlobalAllocationRulesApiGlobalAllocationRulesCreateGlobalRuleAndAllocationRequest = {}, options?: RawAxiosRequestConfig) {
        return GlobalAllocationRulesApiFp(this.configuration).globalAllocationRulesCreateGlobalRuleAndAllocation(requestParameters.createGlobalAllocationAndRulesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GlobalAllocationRulesApiGlobalAllocationRulesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public globalAllocationRulesGet(requestParameters: GlobalAllocationRulesApiGlobalAllocationRulesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return GlobalAllocationRulesApiFp(this.configuration).globalAllocationRulesGet(requestParameters.direction, requestParameters.carrierType, options).then((request) => request(this.axios, this.basePath));
    }
}

